import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'

// Models
import {type DetailedSchoolAdminT} from '@frontrow/console/src/models/school-admin'
// Components
import SchoolAdminDistrictForm from '@frontrow/console/src/components/pages/school-admins-page/school-admins-district-button-modal/school-admins-district-form'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  schoolAdminToUpdate: DetailedSchoolAdminT
  updateSchoolAdminDistricts: (
    schoolAdminId: number,
    addDistrictId: number,
    deleteDistrictId: number
  ) => void
}

function SchoolsAdminDistrictsButtonModal(props: Props): React.ReactElement {
  const {schoolAdminToUpdate, updateSchoolAdminDistricts} = props
  const {isOpen, open, close} = useModalForm()

  const updateSchoolAdminDistrictsHandler = (addDistrictId: number, deleteDistrictId: number) => {
    updateSchoolAdminDistricts(schoolAdminToUpdate.id, addDistrictId, deleteDistrictId)
    close()
  }

  return (
    <React.Fragment>
      <Button style="link" title="Update School Admin District" onClick={open}>
        <i className="fa fa-map fa-lg" />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Update {`${schoolAdminToUpdate.firstName} ${schoolAdminToUpdate.lastName}`} Districts
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <SchoolAdminDistrictForm onSubmit={updateSchoolAdminDistrictsHandler} onCancel={close} />
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default SchoolsAdminDistrictsButtonModal
